module.exports = __webpack_public_path__ + "img/sfondo-riso-e-piselli.032ba561.png";